var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoDirectorio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.5,29.1c-0.2-0.2-0.5-0.4-0.7-0.5c-0.3-0.1-0.6-0.2-0.9-0.2H34.2c-0.3,0-0.6,0.1-0.9,0.2c-0.3,0.1-0.5,0.3-0.7,0.5 c-0.2,0.2-0.4,0.5-0.5,0.8c-0.1,0.3-0.2,0.6-0.2,0.9v26.1h26.3V30.7c0-0.3-0.1-0.6-0.2-0.9S57.7,29.3,57.5,29.1z M55.8,35.5 c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.8s-0.5,0.4-0.7,0.5c-0.3,0.1-0.6,0.2-0.9,0.2h-17c-0.3,0-0.6-0.1-0.9-0.2 c-0.3-0.1-0.5-0.3-0.7-0.5c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.6-0.2-0.9v-2.4c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.5-0.8 c0.2-0.2,0.5-0.4,0.7-0.5c0.3-0.1,0.6-0.2,0.9-0.2h17c0.3,0,0.6,0.1,0.9,0.2s0.5,0.3,0.7,0.5c0.2,0.2,0.4,0.5,0.5,0.8 c0.1,0.3,0.2,0.6,0.2,0.9V35.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 33.1,
    width: 17,
    height: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,11c-18.8,0-34,15.2-34,34c0,18.8,15.2,34,34,34c18.8,0,34-15.2,34-34C79,26.2,63.8,11,45,11z M60.5,56.9 c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.8c-0.2,0.2-0.5,0.4-0.7,0.5c-0.3,0.1-0.6,0.2-0.9,0.2H31.8c0,0.3,0.1,0.6,0.2,0.9 c0.1,0.3,0.3,0.5,0.5,0.8c0.2,0.2,0.5,0.4,0.7,0.5c0.3,0.1,0.6,0.2,0.9,0.2h25.2c0.3,0,0.6,0.1,0.8,0.4c0.2,0.2,0.3,0.5,0.3,0.8 c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.5,0.4-0.8,0.4H34.1c-0.6,0-1.2-0.1-1.7-0.4c-0.6-0.3-1-0.6-1.5-1c-0.4-0.4-0.8-0.9-1-1.5 c-0.2-0.6-0.4-1.2-0.4-1.8V30.7c0-0.6,0.1-1.2,0.4-1.8c0.2-0.6,0.6-1.1,1-1.5c0.4-0.4,0.9-0.8,1.5-1c0.6-0.3,1.1-0.4,1.7-0.4h21.8 c0.6,0,1.2,0.1,1.7,0.4c0.6,0.3,1,0.6,1.5,1c0.4,0.4,0.8,0.9,1,1.5c0.2,0.6,0.4,1.2,0.4,1.8V56.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDirectorio);
export default __webpack_public_path__ + "static/media/ico-directorio.97053b9fbca1993759e6d7d76bfb3465.svg";
export { ForwardRef as ReactComponent };